import React from 'react';
import { connect } from 'react-redux';
import { Grid, CircularProgress } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import BackgroundCatalogVideosCard from './BackgroundCatalogVideosCard';
import EmptyGalleryLabel from '../../../common/EmptyGalleryLabel';
import BackgroundCatalogVideosLoadMoreCard from './BackgroundCatalogVideosLoadMoreCard';

const styles = theme => ({
    galleryProgress: {
        margin: theme.spacing(4, 0, 4, 0) 
    },
    videosContentWrapper: {
        padding: `${theme.spacing(2)} 0`
    }
});

const galleryCardWidth = 222;
const galleryCardHeight = 124;

const BackgroundCatalogVideosContainer = (props) => {
    const { classes, backgroundCatalogVideosInitializing, backgroundCatalogVideos, backgroundCatalogVideosAllCount } = props;

    return (
        <Grid className={classes.videosContentWrapper}>
            <Grid
                container
                direction='row'
                justifyContent='center'
                alignItems='flex-start'
            >
                {backgroundCatalogVideosInitializing ?
                    <Grid className={classes.galleryProgress}>
                        <CircularProgress />
                    </Grid>
                :
                    backgroundCatalogVideos && backgroundCatalogVideos.length
                    ?
                        <>
                            {backgroundCatalogVideos.map((video, index) =>
                                <BackgroundCatalogVideosCard
                                    key={video.id}
                                    index={index}
                                    galleryCardWidth={galleryCardWidth}
                                    galleryCardHeight={galleryCardHeight}
                                />
                            )}

                            {backgroundCatalogVideos.length < backgroundCatalogVideosAllCount && 
                                <BackgroundCatalogVideosLoadMoreCard 
                                    galleryCardWidth={galleryCardWidth}
                                    galleryCardHeight={galleryCardHeight}
                                />
                            }
                        </>
                    :
                    <EmptyGalleryLabel />      
                }
            </Grid>
        </Grid>
    );
};

const mapStateToProps = (state) => {
    const { 
        backgroundCatalogVideosInitializing,
        backgroundCatalogVideos,
        backgroundCatalogVideosAllCount
    } = state.mediaPicker;

    return { 
        backgroundCatalogVideosInitializing,
        backgroundCatalogVideos,
        backgroundCatalogVideosAllCount
    };
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(BackgroundCatalogVideosContainer, styles));